import './index.scss'
export default function TopBackground({ height = 260 }) {
  return (
    <div className="TopBackground">
      <div className="TopBackground_bg" style={{ height }}></div>
    </div>
  )
}
